import { render, staticRenderFns } from "./SearchLongIcon.vue?vue&type=template&id=a528e8c6"
import script from "./SearchLongIcon.vue?vue&type=script&lang=js"
export * from "./SearchLongIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports